module.exports = __webpack_public_path__ + "static/media/slide_en0.0364978d.jpg";